module.exports = __webpack_public_path__ + "static/media/pixel-art.3cc1316e.png";